export default __webpack_public_path__ + "static/media/cryptocurrency.4b4aa565.png";